import React, {Component} from "react";
import { Modal } from "antd";

class Details extends Component {
  render() {
    const {
      commercialProposalDetail,
      visible,
      handleCancel,
      generatePDF
    } = this.props;

    const {
      commercial_quote,
      email_body,
      email_signature,
      email_subject,
      email_to,
      inner_proposals = []
    } = commercialProposalDetail || {};

    return (
      <Modal
        className="md-modal"
        title="Export Details"
        visible={visible}
        onCancel={handleCancel}
        footer={[
          <button key="cancel" className="btn btn-warning" onClick={handleCancel}>Cancel</button>,
          <button key="export" className="btn btn-warning" onClick={generatePDF}>Export</button>,
        ]}
      >
        <div id='content'>
          <table style={{width: "100%"}}>
            <tr>
              <td><h6>HOA:</h6></td>
              <td>{commercial_quote?.community_name || ''}</td>
            </tr>
            <tr>
              <td><h6>Email:</h6></td>
              <td>{commercial_quote?.email_address || ''}</td>
            </tr>
            <tr>
              <td><h6>Community Manager:</h6></td>
              <td>{commercial_quote?.first_name ? `${commercial_quote?.first_name} ${commercial_quote?.last_name}` : ''}</td>
            </tr>
            <tr>
              <td><h6>Management Company:</h6></td>
              <td>{commercial_quote?.management_company || ''}</td>
            </tr>
            <tr>
              <td><h6>Address:</h6></td>
              <td>{commercial_quote?.address?.address}, <br/> {commercial_quote?.address?.city}, {commercial_quote?.address?.state}, {commercial_quote?.address?.zip_code}</td>
            </tr>
          </table>
          <table style={{width: "100%"}}>
            <th>
              <td><h6>Product/Service</h6></td>
              <td><h6>Item</h6></td>
              <td><h6>Model</h6></td>
              <td><h6>Regularity</h6></td>
              <td><h6>Start Month - End Month</h6></td>
              <td><h6>Description</h6></td>
              <td><h6>Discount</h6></td>
              <td><h6>Qty</h6></td>
              <td><h6>Rate</h6></td>
              <td><h6>Rate Tax</h6></td>
              <td><h6>Total</h6></td>
              <td><h6>S & H</h6></td>
              <td><h6>S & H Tax</h6></td>
            </th>
            {inner_proposals?.map(proposal => {
              return proposal?.line_items?.map((item, index) => {
                return (
                  <tr key={index}>
                    <td className={'wrap'}>{item?.item_type || '-'}</td>
                    <td className={'wrap'}>{item?.item || '-'}</td>
                    <td className={'wrap'}>{item?.model || '-'}</td>
                    <td className={'wrap'}>{item?.frequency || '-'}</td>
                    <td className={'wrap'}>{`${item?.start_month} ${item?.end_month}` || '-'}</td>
                    <td className={'wrap'}>{item.description || '-'}</td>
                    <td className={'wrap'}>{item?.discount || '-'}</td>
                    <td className={'wrap'}>{item?.quantity || '-'}</td>
                    <td className={'wrap'}>{item?.rate || '-'}</td>
                    <td className={'wrap'}>{item?.rate_tax || '-'}</td>
                    <td className={'wrap'}>{item?.total || '-'}</td>
                    <td className={'wrap'}>{item?.s_and_h || '-'}</td>
                    <td className={'wrap'}>{item?.s_and_h_tax || '-'}</td>
                  </tr>
                )
              })
            })}
          </table>
          <table style={{width: "100%"}}>
            <tr>
              <td><h6>To:</h6></td>
              <td>{email_to}</td>
            </tr>
            <tr>
              <td><h6>Subject:</h6></td>
              <td>{email_subject}</td>
            </tr>
            <tr>
              <td colSpan={"2"}>{email_body}</td>
            </tr>
            <tr>
              <td><h6>Signature:</h6></td>
              <td>{email_signature}</td>
            </tr>
          </table>
        </div>
      </Modal>
    );
  }
}

export default Details;